import { render, staticRenderFns } from "./groups-list.vue?vue&type=template&id=9ef2b156"
import script from "./groups-list.vue?vue&type=script&lang=js"
export * from "./groups-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports